<script setup>
import { computed } from 'vue';
import SLAMetricCard from './SLAMetricCard.vue';
import { formatMetricWithCount } from 'dashboard/helper/reportMetricHelper';

const props = defineProps({
  noOfBreaches: {
    type: Number,
    required: true,
  },
  noOfConversations: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

// Acertos = total menos as violações — mesma base do "Nº de conversas" e
// "Nº de violações" já exibidos ao lado, então nenhum número novo entra aqui.
const hitRateDisplay = computed(() =>
  formatMetricWithCount(
    props.noOfConversations - props.noOfBreaches,
    props.noOfConversations
  )
);
</script>

<template>
  <div
    class="flex sm:flex-row flex-col w-full gap-4 sm:gap-14 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 px-6 py-5"
  >
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.HIT_RATE.LABEL')"
      :value="hitRateDisplay"
      :tool-tip="$t('SLA_REPORTS.METRICS.HIT_RATE.TOOLTIP')"
      :is-loading="isLoading"
    />

    <div class="w-full sm:w-px bg-n-strong" />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.LABEL')"
      :value="noOfBreaches"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.TOOLTIP')"
      :is-loading="isLoading"
    />
    <div class="w-full sm:w-px bg-n-strong" />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.LABEL')"
      :value="noOfConversations"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.TOOLTIP')"
      :is-loading="isLoading"
    />
  </div>
</template>
